import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize, catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { AccounDataDTO, CategoryDTO, CategoryService, SubCategoryDTO, SubCategoryService } from 'synergy-core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.sass']
})
export class SubCategoryComponent implements OnInit {
  cols!: any[];
  statuses!: any[];
  data!: SubCategoryDTO[];
  filteredData!: any[];
  categories!: CategoryDTO[];
  selectedId!: string;
  submitted: boolean = false;
  loading: boolean = false;
  showDialog: boolean = false;
  buttonDisabled!: boolean;
  entityName: string = "Sub Categorias"
  entityDescription: string = "Mantemiento de sub categorias de productos"
  masterForm!: FormGroup;

  imageFile: any;
  imageMessage!: string;
  inputFile: any;
  currentUser!: AccounDataDTO;

  constructor(
    private categoryService: CategoryService,
    private subCategoryService: SubCategoryService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.getCategories();
    this.getData();
    this.setForm();
    this.setDetail();
  }


  getCategories() {
    let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId );
    this.categoryService.Get(httpParams).subscribe(data => {
      if (data) {
        this.categories = data.Data;
      }
    });
  }

  setForm() {
    this.masterForm = new FormGroup({
      id: new FormControl('00000000-0000-0000-0000-000000000000'),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      categoryId: new FormControl(null, [Validators.required]),
      sortOrder: new FormControl(null, [Validators.required]),
      imageURL: new FormControl(null),
      base64String: new FormControl(null),
      detail: new FormControl(null, [Validators.maxLength(500)]),
      isActive: new FormControl(true),
    });

    this.masterForm.disable();
  }

  setDetail() {
    this.cols = [
      { field: 'Id', header: 'Id' },
      { field: 'Name', header: 'Nombre' },
      { field: 'Detail', header: 'Detalle' },
    ];
  }

  getData() {
    let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId);
    this.subCategoryService.Get(httpParams).subscribe(val => {
      this.data = val.Data;
    });
  }

  getById(id: string) {

    let httpParams = new HttpParams().set('id', id.toString())
      .set('clientId', this.currentUser.ClientId);

    this.subCategoryService.GetById(httpParams).subscribe(val => {
      let data = val.Data[0];
      var timestamp = new Date();

      setTimeout(() => {
        this.masterForm.controls["id"].setValue(data.Id);
        this.masterForm.controls["name"].setValue(data.Name);
        this.masterForm.controls["base64String"].setValue(data.Base64StringImage);
        this.masterForm.controls["imageURL"].setValue(data.ImageURL);
        this.masterForm.controls["categoryId"].setValue(data.CategoryId);
        this.masterForm.controls["sortOrder"].setValue(data.SortOrder);
        this.masterForm.controls["detail"].setValue(data.Detail);
        this.masterForm.controls["isActive"].setValue(data.IsActive);

        if(data.ImageURL){
          this.imageFile = null;
          this.imageFile = environment.imagesURL + data.ImageURL + '?' + timestamp.toTimeString();
        } else{
          this.imageFile = null;
        }

      }, 50);
    });
  }

  onAddNew() {
    this.masterForm.enable();
    this.buttonDisabled = true;
    this.masterForm.reset({ id: '00000000-0000-0000-0000-000000000000', isActive: true });
  }

  onSubmit() {
    this.submitted = true;

    if (this.masterForm.invalid) {
      return;
    }

    this.loading = true;
    let dto = new SubCategoryDTO();

    dto.ClientId = this.currentUser.ClientId;
    dto.Id = this.masterForm.value.id;
    dto.ApplicationId = environment.applicayionId;
    dto.Name = this.masterForm.value.name;
    dto.CategoryId = this.masterForm.value.categoryId;
    dto.Base64StringImage = this.masterForm.value.base64String;
    dto.ImageURL = this.masterForm.value.imageURL;
    dto.Detail = this.masterForm.value.detail;
    dto.SortOrder = this.masterForm.value.sortOrder;
    dto.IsActive = this.masterForm.value.isActive;
    dto.CreatedBy =this.currentUser.Id;
    dto.CreatedDate = new Date();
    dto.ModifiedBy =this.currentUser.Id;
    dto.ModifiedDate = new Date();


    if (this.masterForm.value.id == '00000000-0000-0000-0000-000000000000') {
      this.subCategoryService.Create(dto).pipe(
        finalize(() => {
          this.loading = false;
          this.submitted = false;
          this.onClearImage();
        }),
        catchError((error) => {
          throw error;
        })).subscribe((data) => {
          if (data.Success) {
            this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha creado la subcategoria.' });
            this.masterForm.reset({ phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
            this.masterForm.disable();
            this.buttonDisabled = false;
            this.getData();
          } else {
            this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
          }
        });
    } else {
      this.subCategoryService.Update(dto).pipe(
        finalize(() => {
          this.loading = false;
          this.submitted = false;
          this.onClearImage();
        }),
        catchError((error) => {
          throw error;
        })).subscribe((data) => {
          if (data.Success) {
            this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha actualizado la sub categoria.' });
            this.masterForm.reset({ phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
            this.masterForm.disable();
            this.buttonDisabled = false;
            this.getData();
          } else {
            this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
          }
        });
    }
  }

  onEdit() {
    if (this.selectedId != '') {
      this.masterForm.enable();
      this.buttonDisabled = true;
    }
  }

  onDelete() {
    let httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
      .set('id', this.masterForm.value.id.toString())
      .set('userId', this.currentUser.Id);

    this.confirmationService.confirm({
      message: 'Desea realmente eliminar el registro?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        this.subCategoryService.Delete(httpParams).pipe(
          finalize(() => {
            this.loading = false;
          }),
          catchError((error) => {
            throw error;
          })).subscribe((data) => {
            if (data.Success) {
              this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha eliminado la sub categoria.' });
              this.masterForm.reset();
              this.masterForm.disable();
              this.buttonDisabled = false;
              this.getData();
            } else {
              this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
            }
          });
      },
      reject: () => {
      }
    });
  }

  onShowDialog() {
    this.showDialog = true;
  }

  onSelectFromGrid() {
    this.showDialog = false;
    this.getById(this.selectedId);
  }

  onCancel() {
    this.masterForm.disable();
    this.buttonDisabled = false;
    this.onClearImage();
  }

  onFilter(event: any) {
    let query = event.query;
    this.filteredData = this.filterData(query);
  }

  onSelect(event : any) {
    this.getById(event.Id);
  }

  onSearchImage() {
    $("#inputFile").trigger('click');
  }

  onFileChange(files: any) {
    if (files.length === 0)
      return;
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.imageMessage = "Tipo de archivo no soportado.";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.masterForm.controls["imageURL"].setValue(files[0].name);
      this.imageFile = reader.result;
      this.masterForm.controls["base64String"].setValue(this.imageFile.substr(this.imageFile.indexOf(',') + 1));
    }
  }

  onClearImage() {
    $("#inputFile").val('');
    this.imageFile = null;
    this.imageMessage = null!;
    this.masterForm.controls["imageURL"].setValue("");
  }


  filterData(query : any): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < this.data.length; i++) {
      let current = this.data[i];
      if (current.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(current);
      }
    }
    return filtered;
  }

  get masterControls() {
    return this.masterForm.controls;
  }
}
